var SCM = SCM || {};

SCM.Supplements = SCM.Supplements || {};

SCM.Supplements.updateIssueSupplementsOnChange = function () {
    $('.js-supplements-select').on('change', function () {
        window.location.href = $(this).val();
    });
};

SCM.Supplements.updateIssueSupplementsOnChange();